<nb-card class="dialog-card">
  <nb-card-header>Turma</nb-card-header>
  <nb-card-body>
    <form id="formTurma" #formTurma="ngForm" (ngSubmit)="salvar()">
      <div class="dialog-field-grid">
        <div class="field-block full-row">
          <label for="nome">Nome *</label>
          <input nbInput fullWidth id="nome" required placeholder="Digite o nome da turma" [(ngModel)]="turma.nome" name="nome" />
        </div>
        <div class="field-block full-row">
          <label for="diaSemana">Dia da semana *</label>
          <nb-select id="diaSemana" required placeholder="Selecione o dia" fullWidth [(selected)]="turma.diaSemana" name="diaSemana">
            <nb-option value="Segunda">Segunda</nb-option>
            <nb-option value="Terça">Terça</nb-option>
            <nb-option value="Quarta">Quarta</nb-option>
            <nb-option value="Quinta">Quinta</nb-option>
            <nb-option value="Sexta">Sexta</nb-option>
            <nb-option value="Sábado">Sábado</nb-option>
            <nb-option value="Domingo">Domingo</nb-option>
          </nb-select>
        </div>
        <div class="field-block">
          <label for="horarioInicio">Horário de início *</label>
          <input nbInput fullWidth type="time" id="horarioInicio" required [(ngModel)]="turma.horarioInicio" name="horarioInicio" />
        </div>
        <div class="field-block">
          <label for="horarioFim">Horário de fim *</label>
          <input nbInput fullWidth type="time" id="horarioFim" required [(ngModel)]="turma.horarioFim" name="horarioFim" />
        </div>
        <div class="field-block full-row">
          <label for="ano">Ano *</label>
          <input nbInput fullWidth type="number" id="ano" required [(ngModel)]="turma.ano" name="ano" placeholder="2025" />
        </div>
        <div class="field-block full-row">
          <app-autocomplete
            rotulo="Itinerário"
            placeholder="Digite para buscar o itinerário"
            [opcoes]="opcoesItinerario"
            [selecionadoId]="itinerarioId"
            (selecionadoIdChange)="itinerarioId = $event"
            [permiteTodos]="true"
            rotuloTodos="Nenhum"
            msgSemResultado="Nenhum itinerário encontrado"
          ></app-autocomplete>
        </div>
        <div class="field-block full-row checkbox-ativa">
          <nb-checkbox id="turmaAtiva" name="turmaAtiva" [(ngModel)]="turma.ativo">
            Turma ativa
          </nb-checkbox>
          <span class="checkbox-hint">Desmarque para inativar a turma no sistema (não exclui dados nem matrículas).</span>
        </div>
      </div>
    </form>
  </nb-card-body>
  <nb-card-footer class="footer-actions">
    <button nbButton status="basic" type="button" size="medium" (click)="fechar()">Cancelar</button>
    <button nbButton status="primary" type="submit" size="medium" form="formTurma">Salvar</button>
  </nb-card-footer>
</nb-card>
